import React from 'react';
import { withRouter } from 'react-router-dom';
import InfoContent from '../components/InfoContent';

const BTN = {
  background: '#383838', color: '#aaa', border: '1px solid #444',
  borderRadius: '3px', padding: '2px 8px', fontSize: '9px',
  cursor: 'pointer', letterSpacing: '0.5px', marginRight: '6px',
  fontFamily: 'inherit', lineHeight: 'normal'
};

function Info({ history }) {
  return (
    <div className="page-vaults">
      <div className="models-border">
        <div className="models-border-content vaults-content">

          <div style={{ display: 'flex', alignItems: 'center', padding: '4px 2px', flexShrink: 0 }}>
            <button style={BTN} onClick={() => history.push('/dashboard')}>
              ← DASHBOARD
            </button>
            <span style={{ color: '#444', fontSize: '9px', letterSpacing: '2px' }}>INFO</span>
          </div>

          <div className="models-border-2" style={{ flex: 1, minHeight: 0 }}>
            <div className="models-border-content-2" style={{ height: '100%', overflow: 'hidden' }}>
              <InfoContent />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default withRouter(Info);
